import { Icon } from '../types/icons';

export const specialIcons: Icon[] = [
  { key: 'width', url: 'https://cdn.easysize.me/icons/width.svg' },
  { key: 'bulb', url: 'https://cdn.easysize.me/icons/lightbulb.svg' },
  { key: 'bullseye', url: 'https://cdn.easysize.me/icons/bullseye.svg' },
  { key: 'robot', url: 'https://cdn.easysize.me/icons/robot.svg' },
  { key: 'question', url: 'https://cdn.easysize.me/icons/question.svg' },
  { key: 'bookmark', url: 'https://cdn.easysize.me/icons/bookmark.svg' },
  { key: 'bookmark-2', url: 'https://cdn.easysize.me/icons/bookmark-2.svg' },
  { key: 'sparkle', url: 'https://cdn.easysize.me/icons/sparkle.svg' },
  { key: 'sparkle-2', url: 'https://cdn.easysize.me/icons/sparkle-2.svg' },
];
